<template>
  <LeftPanel :title="'Пользователь'" @close="panelClose" :show="panelShow">
    <pre>{{this.panelData}}</pre>
  </LeftPanel>
  <DataTable
      :columns="columns"
      :data="userList"
      @row-dblclick="showUser"
  >
  </DataTable>
</template>

<script>
import LeftPanel from "@/components/panel/LeftPanel.vue";
import DataTable from "@/components/DataTable.vue";

export default {
  name: 'UserListPage',
  components: {DataTable, LeftPanel},
  data() {
    return {
      panelShow: false,
      panelData: null,
      userList: null,
      columns: [
        {
          name: "id",
          title: "ID",
        },
        {
          name: "username",
          title: "Username",
        },
        {
          name: "email",
          title: "Email",
        },
        {
          name: "createdAt",
          title: "Создан",
        }
      ]
    }
  },
  methods: {
    panelClose() {
      this.panelShow = false;
      this.panelData = null;
    },
    showUser(item) {
      console.log("show tariff", item)
      this.panelShow = true;
      this.panelData = item;
    },
    loadUserList: function () {
      console.log("load user list")
      let c = this;
      this.axios.get('/api/admin/user', this.formData).then(function(response) {
        console.log(response.data);
        c.userList = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
      });
    }
  },
  mounted() {
    this.loadUserList()
  }
}
</script>

<style scoped>

</style>